import { useEffect, useState } from "react";
import { Check, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api, fmtErr } from "../lib/api";

const ORDER = ["marketing", "vendite", "completo"];

/* Le tre offerte con interruttore mensile/annuale e pulsante «Attiva» → Stripe Checkout. */
export default function PlanPicker({ compact = false, current }) {
  const [b, setB] = useState(null);
  const [yearly, setYearly] = useState(false);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/billing").then(({ data }) => setB(data)).catch(() => {}); }, []);
  if (!b) return null;
  const checkout = async (id) => {
    setBusy(id);
    try { const { data } = await api.post("/payments/checkout", { lookup_key: `${id}_${yearly ? "yearly" : "monthly"}`, origin_url: window.location.origin }); window.location.href = data.checkout_url; }
    catch (e) { toast.error(fmtErr(e)); setBusy(""); }
  };
  const call = () => window.open(b.calendar_url, "_blank", "noopener");
  return (
    <div data-testid="plan-picker">
      <div className="mb-4 flex justify-center">
        <div className="inline-flex rounded-full border border-line p-0.5 text-xs" data-testid="billing-toggle">
          {[["m", "Mensile"], ["y", "Annuale · 2 mesi gratis"]].map(([k, l]) => (
            <button key={k} onClick={() => setYearly(k === "y")} data-testid={`billing-${k}`} className={`rounded-full px-4 py-1.5 ${yearly === (k === "y") ? "seg-on" : "text-slate-400 hover:text-slate-100"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {ORDER.map((id) => {
          const p = b.plans[id]; const active = current === id; const rec = id === "completo";
          return (
            <div key={id} data-testid={`plan-${id}`} className={`relative flex flex-col rounded-xl border p-5 ${rec ? "border-[#C5A059]/60 bg-[#C5A059]/5" : "border-line"}`}>
              {rec && <span className="absolute -top-2.5 left-5 rounded-full bg-[#C5A059] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-black">Consigliato</span>}
              <div className="flex items-center justify-between"><span className="text-lg font-semibold text-slate-100">{p.label}</span>{active && <span className="rounded-full bg-[#C5A059]/20 px-2 py-0.5 text-xs font-semibold text-[#E5C158]">ATTIVO</span>}</div>
              <div className="mt-2"><span className="text-3xl font-semibold tabular-nums text-slate-50">€{yearly ? p.yearly_month : p.monthly}</span><span className="text-sm text-slate-400"> /mese · IVA inclusa</span>
                {yearly && <div className="text-xs text-slate-500">fatturato €{p.yearly_month * 12}/anno in un'unica soluzione</div>}</div>
              {!compact && <ul className="mt-3 flex-1 space-y-1.5">{p.includes.map((f) => <li key={f} className="flex items-start gap-2 text-xs text-slate-300"><Check className="mt-0.5 h-3 w-3 shrink-0 text-[#C5A059]" /> {f}</li>)}</ul>}
              <ul className="mt-3 space-y-1 border-t border-line pt-2">{p.limits.map((f) => <li key={f} className="text-xs text-slate-500">· {f}</li>)}</ul>
              <button onClick={() => checkout(id)} disabled={!!busy || active} data-testid={`plan-select-${id}`} className={`mt-4 w-full ${rec ? "btn btn-primary" : "btn btn-secondary"} justify-center disabled:opacity-50`}>
                {busy === id ? "Apro il pagamento…" : active ? "Piano attuale" : "Attiva"}
              </button>
            </div>
          );
        })}
      </div>
      <p className="mt-3 text-center text-xs text-slate-500">Pagamento sicuro con carta su Stripe · fattura automatica via email. Più sedi o oltre 10 venditori: <button onClick={call} className="text-[#C5A059] hover:underline" data-testid="plan-su-misura">piano su misura <ExternalLink className="inline h-3 w-3" /></button></p>
    </div>
  );
}
